<template>
  <div>
    <Card :bordered="false" dis-hover class="ivu-mt">
      <Form ref="userForm" :model="userForm"  :label-width="100" label-position="right" @submit.native.prevent>
        <Row :gutter="24" type="flex" justify="end">
          <Col span="24" class="ivu-text-left">
            <FormItem label="订单状态：">
              <RadioGroup v-model="userForm.status" type="button"  @on-change="selectChange2(userForm.status)">
                <Radio label="">全部</Radio>
                <Radio label="1">待支付</Radio>
                <Radio label="2">待发货</Radio>
                <Radio label="3">待收货</Radio>
                <Radio label="5">交易完成</Radio>
                <Radio label="6">已取消</Radio>
              </RadioGroup>
            </FormItem>
          </Col>
          <Col span="24">
            <Col span="8">
              <FormItem label="搜索：" prop="key" label-for="key">
                <Input v-model="userForm.key" search enter-button placeholder="请输入订单编号|收货人电话|收货人姓名" @on-search="userSearchs()"></Input>
              </FormItem>
            </Col>
            <Col span="16">
              <Select v-model="userForm.store_id" style="width:200px;margin-left: 20px" placeholder="请选择店铺名称" @on-change="changeSelect">
                <Option value="0">全部店铺</Option>
                <Option v-for="(item, key) in storeInfo" :value="key" :key="key">{{ item }}</Option>
              </Select>
            </Col>
<!--            <Col v-bind="grid">-->
<!--            <Button class="mr">报告导出</Button>-->
<!--            <span class="Refresh" @click="Refresh">刷新</span><Icon type="ios-refresh" />-->
<!--            </Col>-->
          </Col>
        </Row>
      </Form>
      <Table :columns="columns2" :data="orderInfo" ref="table" class="ivu-mt"
             :loading="loading"
             no-userFrom-text="暂无数据"
             no-filtered-userFrom-text="暂无筛选结果"
      >
        <template slot-scope="{ row, index }" slot="goods_info">
          <span v-for="(item,index) in row.orderDetail" :key="index">
            {{item.goods_title}}  (
            x {{item.num}})<br/>
          </span>
        </template>
        <template slot-scope="{ row, index }" slot="status">
          <Tag color="red" v-if="row.status===0">待支付</Tag>
          <Tag color="green" v-else-if="row.status===1">待发货</Tag>
          <Tag color="cyan" v-else-if="row.status===2">待收货</Tag>
          <Tag color="orange" v-else-if="row.status===3">已完成</Tag>
          <Tag color="orange" v-else-if="row.status===4">已取消</Tag>
        </template>
        <template slot-scope="{ row, index }" slot="delivery_status">
          <span v-if="row.delivery_status===0" style="color: red">待发货</span>
          <span v-else-if="row.delivery_status===1">已发货</span>
          <span v-else-if="row.delivery_status===2">同城配送</span>
        </template>
        <template slot-scope="{ row, index }" slot="action">
          <a @click="info(row)">查看</a>
          <Divider type="vertical"/>
          <a @click="deliver(row)" :disabled="row.status !== 1 && row.status !== 2">发货</a>
          <Divider type="vertical"/>
          <a @click="info(row)">退换</a>

          <!--          <a @click="delivery(row)">发送货</a>-->
        </template>
      </Table>
      <Page :total="dataCount" :current="userForm.page" :page-size="userForm.limit" class="acea-row row-right page" show-total  @on-change="changepage"></Page>
    </Card>
    <!--发送货-->
    <orderEdit ref="orderEdit" :editShow="editShow" :id="order_id" @updateStatusModel="updateStatusModel"></orderEdit>


    <Modal v-model="deliverShow" title="订单发货">
      <Form ref="deliverForm" :model="deliverForm" :label-width="100" label-position="right" @submit.native.prevent style="padding:20px">
        <FormItem label="发货状态：" prop="status" label-for="status">
          <RadioGroup v-model="deliverForm.status" type="button" style="margin-bottom: 20px">
            <Radio :label="1" disabled="disabled">未发货</Radio>
            <Radio :label="2" disabled="disabled">已发货</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="快递单号：" prop="logistics_no" label-for="logistics_no">
          <Input v-model="deliverForm.logistics_no" placeholder="请输入快递单号" style="width: 300px"></Input>
        </FormItem>

      </Form>
      <div slot="footer">
        <Button @click="deliverCancel">取消</Button>
        <Button type="primary" @click="deliverOk">提交</Button>
      </div>
    </Modal>



  </div>
</template>

<script>
import { orderList, orderDeliveryApi } from '@/api/order'
import orderEdit from './components/orderEdit'
import { shopAllApi } from '@/api/shop/shop'
export default {
  name: 'listDetail',
  components: { orderEdit },
  inject: ['reload'],
  props: ['tagId'],
  data () {
    return {
      userForm: {
        page: 1,
        limit: 10,
        store_id: '0',
        key: '',
        status: ''
      },
      deliverShow: false,
      deliverForm: {
        order_id: 0,
        status: 2,
        logistics_no: ''
      },
      editShow: false,
      order_id: 0,
      dataCount: 0,
      confirm: false,
      orderInfo: [],
      storeInfo: [],
      loading: false,
      columns2: [
        {
          title: '订单编号',
          key: 'order_sn',
          minWidth: 120
        },
        {
          title: '用户昵称',
          key: 'nickname',
          minWidth: 120
        },
        {
          title: '联系电话',
          key: 'receiver_phone',
          minWidth: 120
        },
        {
          title: '店铺名称',
          key: 'shop_name',
          minWidth: 200
        },
        {
          title: '商品信息',
          slot: 'goods_info',
          minWidth: 400
        },
        {
          title: '实际支付',
          key: 'total_fee',
          minWidth: 120
        },
        {
          title: '状态',
          slot: 'status',
          minWidth: 120
        },
        {
          title: '发货状态',
          slot: 'delivery_status',
          minWidth: 120
        },
        {
          title: '物流单号',
          key: 'logistics_no',
          minWidth: 180
        },
        {
          title: '合并订单编号',
          key: 'all_order_sn',
          minWidth: 180
        },
        {
          title: '创建时间',
          key: 'ctime',
          minWidth: 150
        },
        {
          title: '操作',
          slot: 'action',
          fixed: 'right',
          minWidth: 180
        }
      ]
    }
  },
  created: function () {
    this.orderList()
    this.getStore()
  },
  watch: {
    tagId (val) {
      this.userForm.tags = val
      this.orderList()
    }
  },
  methods: {
    orderList () {
      this.loading = true
      orderList(this.userForm).then(res => {
        let data = res.data
        this.orderInfo = data.list
        this.dataCount = data.count
        this.loading = false
      }).catch(res => {
        this.loading = false
        this.$Message.error(res.msg)
      })
    },
    // 分页
    changepage (status) {
      this.userForm.page = status
      this.orderList()
    },
    // 表格搜索
    userSearchs () {
      this.userForm.page = 1
      this.orderList()
    },
    selectChange () {
      this.userForm.key = ''
    },
    info (row) {
      this.$router.push({ path: '/admin/order/detail/' + row.order_id })
    },
    delivery (row) {
      this.order_id = row.order_id
      this.editShow = true
    },
    updateStatusModel (modalStatus) {
      this.editShow = modalStatus
      this.reload()
    },
    selectChange2 (status) {
      this.userForm.status = status
      this.orderList()
    },
    getStore () {
      shopAllApi(this.userForm).then(res => {
        this.storeInfo = res.data
      }).catch(res => {
        this.loading = false
        this.$Message.error(res.msg)
      })
    },
    changeSelect (val) {
      this.userForm.store_id = val
      this.orderList()
    },


    // 发货 展示
    deliver(row){
      this.deliverForm.order_id = row.order_id
      this.deliverForm.status = row.status
      this.deliverForm.logistics_no = row.logistics_no
      this.deliverShow = true
    },

    // 发货 确认
    deliverOk() {
      orderDeliveryApi(this.deliverForm).then(res => {
        if (res.code === 200) {
          this.$Message.success('成功')
          this.deliverShow = false
          this.reload()
        } else {
          this.$Message.error(res.msg)
        }
      }).catch(res => {
        this.$Message.error(res.msg)
      })
    },
    // 发货 取消
    deliverCancel() {
      this.deliverForm.order_id = 0
      this.deliverForm.status = 2
      this.deliverForm.logistics_no = ''
      this.deliverShow = false
    },





  }
}
</script>
